import { FC, useEffect } from 'react';

import { BANNER_IMAGE_CROP_DEFAULT, BANNER_IMAGE_CROP_TYPES, ImageComponent, ImageType } from 'utils/constants/banner';
import { CampaignProcess } from 'utils/constants/campaign';

import { loadImage } from 'components/common/BannerImg/loadImage';
import { UploadedImage } from 'components/common/BannerImg/UploadedImage/UploadedImage';
import { UploadField } from 'components/common/BannerImg/UploadField/UploadField';

import { setBannerImageComponentByType } from 'store/models/createBanner';
import { useDispatch, useSelector } from 'store/utils';

export const BannerImg: FC = () => {
    const { images, bannerId, isCropsSaved } = useSelector((state) => state.createBanner);
    const { campaignProcess } = useSelector((state) => state.createCampaign);

    const dispatch = useDispatch();

    const isImageUploaded = !!images[BANNER_IMAGE_CROP_DEFAULT].url;
    const isCampaignCopyProcess = campaignProcess === CampaignProcess.Copy;

    // TODO: Нужно заменить на параллельную загрузку после https://jira.hh.ru/browse/HH-200015
    const uploadImagesCopy = async () => {
        for (const cropType of BANNER_IMAGE_CROP_TYPES) {
            if (!images[cropType].id) {
                return;
            }

            dispatch(
                setBannerImageComponentByType({
                    cropType,
                    component: ImageComponent.Loading,
                })
            );

            // eslint-disable-next-line no-await-in-loop
            await dispatch(
                loadImage({
                    imageType: ImageType.Gallery,
                    fileName: images[cropType].fileName as string,
                    cropType,
                    id: images[cropType].id,
                    resetBannerImagesOnFail: true,
                })
            );
        }
    };

    useEffect(() => {
        if (isCampaignCopyProcess) {
            void uploadImagesCopy();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            {isImageUploaded && (isCropsSaved || bannerId || isCampaignCopyProcess) ? (
                <UploadedImage />
            ) : (
                <UploadField />
            )}
        </>
    );
};
